import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {LocationService} from "../../services/LocationService";

export class ReportLocationModel {
    static $inject = ['$q','FileSaver','Blob','LocationService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    searchText:string = "";
    totalCount:number = 0;
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public locationService:LocationService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        this.getCount();
    }
    getReport():ng.IPromise<any>{
        return this.locationService.getReport(this.searchText).then((data)=>{
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'locations.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.locationService.getCount(this.searchText)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }

}
